import { defineComponent, h } from 'vue';
import './VSpacer.scss';

export default defineComponent({
  render() {
    return h('div', { class: 'v-spacer' });
  },
});
